import React from "react";
import { User } from "../../entities/interfaces/users";
import { Button, Table, Tag } from "antd";

type Props = {
  users: User[];
  onSelect: (user: User) => void;
};

const UserList = ({ users, onSelect }: Props) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Status",
      key: "active",
      render: (record: any) => {
        return record.active ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => {
        return (
          <Button size="small" onClick={() => onSelect(record)}>
            Update
          </Button>
        );
      },
    },
  ];

  return <Table dataSource={users} columns={columns} />;
};

export default UserList;
